import * as ActionTypes from './actionTypes'

// Set Nav Selected Tab Key
export function setSelectedTabKey(selectedTabKey) {
  return dispatch => {
    dispatch({ type: ActionTypes.SET_SELECTED_TAB_KEY, payload: selectedTabKey })
  }
}